import { isPossiblePhoneNumber } from 'react-phone-number-input';

/** Inline message shown when a non-empty phone fails the client-side check. */
export const PHONE_INVALID_MESSAGE =
  'Enter a valid phone number, including country code';

export type PhoneValidationResult =
  | { ok: true; value?: string }
  | { ok: false; error: string };

/**
 * Validate an E.164 phone for an OPTIONAL field.
 *
 * - Blank/undefined → ok with `value: undefined` so callers OMIT the key
 *   (the API 422s on `""`, accepts a missing/null phone).
 * - Non-empty → must pass `isPossiblePhoneNumber` (length/shape check; we
 *   deliberately avoid the stricter `isValidPhoneNumber`, whose stale
 *   numbering-plan metadata can reject real numbers — see design doc).
 */
export function validateOptionalPhone(value?: string): PhoneValidationResult {
  if (!value?.trim()) return { ok: true, value: undefined };
  if (!isPossiblePhoneNumber(value)) return { ok: false, error: PHONE_INVALID_MESSAGE };
  return { ok: true, value };
}
